import {
  IndexDBFileSystemStorageAdapter,
  type LocalStorageAdapter,
} from "@powersync/web"

/**
 * Attachment bytes on the PWA stay in IndexedDB, one database per queue. The
 * native build keeps them as files instead (see ../native/attachmentStorage).
 */
export function createAttachmentStorage(name: string): LocalStorageAdapter {
  return new IndexDBFileSystemStorageAdapter(name)
}
